<template>
  <section class="financial-institutions" v-if="!loaded">
    <div v-if="getUser">
      <alert-main v-if="!getUser.hasTerminal" title="У вас не настроен терминал." description="Пожалуйста, обратитесь к ответственному бухгалтеру. <br/>Если терминал настроен, необходимо обновить токен или вновь авторизоваться."/>
    </div>
    <section v-if="ticket === null">
      <div class="row">
        <div class="col-xl-6 col-xxl-4">
          <section class="insurer mb-5">
            <h6 class="mb-5 text-gray-700">Страхователь</h6>
            <customer-card
                v-if="this.policy.insurer"
                :client="this.policy.insurer"
                :beingVerify="false"
                :key-item="0"
                :class="(this.policy.insurer.podft && !this.policy.insurer.podft.success) ? 'invalid' : ''"
                :module="FiModule">
              <template v-slot:change v-if="!changeDisabled">
                <span v-if="this.policy.insurer.podft.success"
                      class="edit-item"
                      @click="setClient(1, this.policy.insurer)">
                  <i class="ki-outline ki-notepad-edit fs-3"></i>
                </span>
                <template v-else>
                  <span v-if="this.policy.insurer.podft.setDocument"
                        class="add-item"
                        @click="uploadData(this.policy.insurer.podft.id, this.policy.insurer.client.iin, 0, 0)">
                    <i class="ki-outline ki-message-add fs-3"></i>
                  </span>
                </template>
              </template>
              <template v-slot:footer>
                <div v-if="this.policy.insurer && !this.policy.insurer.filter.person"
                     class="border-top py-4 px-5 text-start">
                  <div class="pb-2 border-bottom">
                    <div class="fs-8 text-gray-600 required">Руководитель</div>
                    <div v-if="policy.insurer.leader && policy.insurer.leader.title"
                         class="d-flex justify-content-between">
                      <div class="fs-7 text-gray-800" v-html="policy.insurer.leader.title"></div>
                      <div v-if="policy.insurer.leader.added && !changeDisabled" class="card_change"
                           @click="deleteChief(null, true)">
                        <span class="delete-item"><i class="ki-outline ki-cross-square fs-3"></i></span>
                      </div>
                    </div>
                    <span v-else-if="!changeDisabled" class="fs-7 text-primary cursor-pointer" @click="setChief(true)">Добавить</span>
                  </div>
                  <div>
                    <div class="fs-8 text-gray-600 required">Бенефициарный собственник</div>
                    <template v-if="policy.insurer.beneficiaries && policy.insurer.beneficiaries.length">
                      <div class="d-flex justify-content-between"
                           v-for="(item, key) in policy.insurer.beneficiaries"
                           :key="key">
                        <div class="fs-7 text-gray-800 my-1" v-html="item.title"></div>
                        <div v-if="item.added && !changeDisabled" class="card_change" @click="deleteChief(key)">
                          <span class="delete-item"><i class="ki-outline ki-cross-square fs-3"></i></span>
                        </div>
                      </div>
                    </template>
                    <span v-if="!changeDisabled" class="fs-7 text-primary cursor-pointer" @click="setChief(false)">Добавить</span>
                  </div>
                </div>
                <div v-if="!changeDisabled" class="border-top pt-4 pb-4">
                  <checkbox-field
                      v-model="policy.isDrive"
                      placeholder="Страхователь является застрахованным"
                      id="is.driver"
                      class="form-check-sm justify-content-center"
                  />
                </div>
              </template>
            </customer-card>
            <div v-if="!this.policy.insurer && !changeDisabled" class="empty-card opacity-75" @click="setClient(1)">
              <span class="fs-7 text-primary">Добавить</span>
            </div>
          </section>
          <section class="beneficiary mb-5" :class="!this.policy.insurer ? 'opacity-50' : ''">
            <h6 class="mb-5 text-gray-700">Выгодоприобретатель</h6>
            <customer-card
                v-if="this.policy.beneficiary"
                :client="this.policy.beneficiary"
                :beingVerify="false"
                :key-item="0"
                :module="FiModule">
              <template v-slot:change>
              <span v-if="!changeDisabled && !this.policy.objects.length > 0" class="delete-item" @click="this.policy.beneficiary = null">
                <i class="ki-outline ki-cross-square fs-3"></i>
              </span>
              </template>
            </customer-card>
            <template v-else-if="!changeDisabled">
              <div v-if="this.policy.insurer"
                   @click="setClient(3)"
                   class="empty-card">
                <span class="fs-7 text-primary">Добавить</span>
              </div>
              <div v-else class="empty-card">
                <span class="fs-7 text-primary">Добавить</span>
              </div>
            </template>
          </section>
        </div>
        <div class="col-xl-6 col-xxl-4" :class="!this.policy.insurer ? 'opacity-50' : ''">
          <section class="insureds">
            <h6 class="mb-5 text-gray-700">Застрахованный</h6>
            <template v-if="this.policy.insureds.length">
              <customer-card
                  v-for="(item, key) in this.policy.insureds"
                  :key="key"
                  :changeDisabled="this.changeDisabled"
                  :key-item="key"
                  :client="item"
                  :class="errorClientKey.includes(key.toString()) || (item.podft && !item.podft.success) ? 'invalid' : ''"
                  :module="FiModule">
                <template v-slot:change v-if="!changeDisabled">
                  <template v-if="!(item.podft && !item.podft.success)">
                <span
                    v-if="item.client.iin"
                    class="edit-item"
                    @click="setClient(2, item, key)">
                  <i class="ki-outline ki-notepad-edit fs-3"></i>
                </span>
                  </template>
                  <template v-else>
                <span
                    class="add-item"
                    v-if="item.podft.setDocument"
                    @click="uploadData(this.policy.insureds[key].podft.id, this.policy.insureds[key].client.iin, 1, key)">
                  <i class="ki-outline ki-message-add fs-3"></i>
                </span>
                  </template>
                  <span class="delete-item" @click="deleteClient(key)">
                <i class="ki-outline ki-cross-square fs-3"></i>
              </span>
                </template>
              </customer-card>
            </template>
            <template v-if="!changeDisabled">
              <div
                  v-if="this.policy.insurer"
                  @click="setClient(2)"
                  class="empty-card">
                <span class="fs-7 text-primary">Добавить</span>
              </div>
              <div v-else class="empty-card">
                <span class="fs-7 text-primary">Добавить</span>
              </div>
            </template>
          </section>
        </div>
        <div class="col-xl-6 col-xxl-4" :class="!this.policy.insurer ? 'opacity-50' : ''">
          <div class="program mb-5" v-if="this.policy.insurer">
            <h6 class="mb-5 text-gray-700">Программа</h6>
            <div class="rounded border pb-6 p-6 bg-white info-panel">
              <switch-box-field
                  v-if="!policy.objects.length"
                  v-model="policy.conditions.is_immovable"
                  :disabled="policy.objects.length"
                  placeholder="Является недвижимым"
                  id="conditions.is_immovable"
                  :size="'h-20px w-30px'"
                  :class="policy.objects.length ? '' : 'mb-5'"
              />
              <div class="info-panel rounded border p-5" v-if="!policy.objects.length">
                <h5 class="text-gray-700 mb-5 fs-7 required"
                    v-html="policy.conditions.is_immovable ? 'Недвижимое имущество' : 'Движимое имущество'"></h5>
                <div class="form-check form-check-custom form-check-solid form-check-sm mb-3"
                     v-for="(item, key) in this.kinds()" :key="key"
                     @click="policy.conditions.kind = item; policy.selected.kind = key">
                  <input class="form-check-input" type="radio" :checked="this.policy.selected.kind === key"
                         :id="'conditions-kind-'+key" name="conditions-kind"/>
                  <label class="form-check-label" :for="'conditions-kind-'+key" v-html="item"></label>
                </div>
              </div>
              <div v-else class="text-primary opacity-50">
                <b class="fw-bolder"
                   v-html="policy.conditions.is_immovable ? 'Недвижимое имущество' : 'Движимое имущество'"></b> -
                <span v-html="policy.conditions.kind"></span>
              </div>
            </div>
          </div>
          <section class="object" :class="(!this.policy.conditions.kind || !this.policy.beneficiary) ? 'opacity-50' : ''">
            <h6 class="mb-5 text-gray-700">Объект</h6>
            <template v-if="policy.objects.length">
              <object-one-c-card
                  v-for="(item, key) in policy.objects"
                  :key="key"
                  :object="item"
                  :isImmovable="policy.conditions.is_immovable">
                <template v-slot:change>
                  <template v-if="!changeDisabled">
                                  <span class="edit-item" @click="setChangedObject(key, true)">
                  <i class="ki-outline ki-notepad-edit fs-3"></i>
                </span>
                    <span class="delete-item" @click="deleteObject(key)">
                  <i class="ki-outline ki-cross-square fs-3"></i>
                </span>
                  </template>
                </template>
              </object-one-c-card>
            </template>
            <template v-if="!changeDisabled">
              <div v-if="this.policy.conditions.kind && this.policy.beneficiary" @click="setObject" class="empty-card">
                <span class="fs-7 text-primary">Добавить</span>
              </div>
              <div v-else class="empty-card">
                <span class="fs-7 text-primary">Добавить</span>
              </div>
            </template>
          </section>
        </div>
      </div>
      <hr class="text-gray-400" v-if="policy.insurer && policy.insurer.hasOwnProperty('client')">
      <div class="row" v-if="policy.insurer && policy.insurer.hasOwnProperty('client')">
        <div class="col-xl-6 col-xxl-4">
          <program-condition :programCondition="policy.programCondition" :isPerson="policy.insurer.filter.person"
                             :role="getUser.role" :change-disabled="changeDisabled" :module="FiModule">
            <template v-slot:riskBtn>
              <button type="button" class="btn btn-light-primary btn-sm btn-block" data-bs-toggle="modal"
                      data-bs-target="#InsuranceRisksModal">
                Страховые риски
              </button>
            </template>
          </program-condition>
          <div class="mb-5" v-if="policy.hasPaid && policy.insurer.hasOwnProperty('signatory')">
            <h6 class="mb-5 text-gray-700">Информация о подписанте-страхователе</h6>
            <div class="rounded border p-6 bg-white info-panel border-opacity-50"
                 :class="clientSignatoryCheck ? 'border-success' : 'border-danger'">
              <div class="rounded border p-3 mb-3 mt-3">
                <switch-box-field
                    v-model="policy.insurer.signatory.resident"
                    placeholder="Резидент"
                    id="policy.insurer.signatory.resident"
                    :size="'h-20px w-30px'"
                />
              </div>
              <input-mask-field
                  v-if="policy.insurer.signatory.resident"
                  v-model="policy.insurer.signatory.iin"
                  :required="true"
                  id="policy.insurer.signatory.iin"
                  name="policy.insurer.signatory.iin"
                  placeholder="ИИН"
                  :mb="5"
                  mask="############"
                  type="text"
              />
              <input-field
                  v-model="policy.insurer.signatory.surname"
                  :required="true"
                  id="policy.insurer.signatory.surname"
                  name="policy.insurer.signatory.surname"
                  placeholder="Фамилия"
                  type="text"
                  mb="5"
              />
              <input-field
                  v-model="policy.insurer.signatory.name"
                  :required="true"
                  id="policy.insurer.signatory.name"
                  name="policy.insurer.signatory.name"
                  placeholder="Имя"
                  type="text"
                  mb="5"
              />
              <input-field
                  v-model="policy.insurer.signatory.patronymic"
                  id="policy.insurer.signatory.patronymic"
                  name="policy.insurer.signatory.patronymic"
                  placeholder="Отчество"
                  type="text"
                  mb="5"
              />
              <input-field
                  v-model="policy.insurer.signatory.position"
                  :required="true"
                  id="policy.insurer.signatory.position"
                  name="policy.insurer.signatory.position"
                  placeholder="Должность"
                  type="text"
                  mb="5"
              />
              <div class="custom-select dynamic">
                <label for="policy.insurer.signatory.foundation_type">Основание</label>
                <v-select
                    v-model="policy.insurer.signatory.foundation_type"
                    input-id="policy.insurer.signatory.foundation_type"
                    :options="getDocType()"
                    :reduce="item => item.id"
                    :required="true"
                    placeholder="Выберите..."
                    class="mb-5 bg-gray-100 form rounded"
                    label="name"
                />
              </div>
              <input-field
                  v-if="policy.insurer.signatory.foundation_type !== 'Устав'"
                  v-model="policy.insurer.signatory.foundation_number"
                  :required="true"
                  id="policy.insurer.signatory.foundation_number"
                  name="policy.insurer.signatory.foundation_number"
                  placeholder="Номер документа"
                  type="text"
                  mb="5"
              />
              <date-field
                  v-if="policy.insurer.signatory.foundation_type !== 'Устав'"
                  v-model="policy.insurer.signatory.foundation_date"
                  :required="true"
                  id="policy.insurer.signatory.foundation_date"
                  name="policy.insurer.signatory.foundation_date"
                  placeholder="Дата Документа"
                  mb="5"
              />
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-xxl-4">
          <section class="history-and-contract mb-5">
            <h6 class="mb-5 text-gray-700">История / Договор</h6>
            <div class="rounded border info-panel bg-white p-5">
              <switch-box-field
                  v-model="policy.conditions.has_losses"
                  :disabled="changeDisabled"
                  placeholder="Были ли у Вас за прошедшие 3 года убытки по рискам, которые необходимо застраховать"
                  id="conditions.losses"
                  :size="'h-20px w-30px'"
                  class="mb-5"
              />
              <switch-box-field
                  :disabled="policy.hasPaid || changeDisabled"
                  v-model="policy.conditions.is_indoors"
                  placeholder="Имущество, передаваемое на страхование, находится на территории страхования"
                  id="conditions.is_indoors"
                  :size="'h-20px w-30px'"
              />
            </div>
          </section>
        </div>
      </div>
      <hr class="text-primary opacity-20" v-if="policy.insurer && policy.insurer.hasOwnProperty('client')">
      <div class="row" v-if="policy.insurer && policy.insurer.hasOwnProperty('client')">
        <div class="col-xl-6 col-xxl-4">
          <div class="contract mb-5">
            <h6 class="mb-5 text-gray-700">Договор</h6>
            <div class="pb-7" v-if="policy.hasPaid">
              <div class="rounded border p-6 bg-white info-panel">
                <div class="text-gray-500 fs-8 mb-1">Дата калькуляции: <span class="float-end"
                                                                             v-html="policy.calculationDate"></span>
                </div>
                <div class="text-gray-500 fs-6 mb-1">Тариф: <span class="float-end" v-html="policy.tariff"></span></div>
                <div class="fw-bold" style="font-size: 20px">
                  Итого к оплате: <span class="float-end">
                  {{ policy.premium.toLocaleString('ru-RU') }} тг.
                </span>
                </div>
              </div>
            </div>
            <div class="pb-7">
              <div class="rounded border p-6 bg-white info-panel">
                <div class="row">
                  <div class="col-xxl-6 col-xl-12">
                    <date-field
                        v-model="policy.treaty.date"
                        :required="true"
                        :mb="5"
                        placeholder="Дата начала договора"
                        name="treaty_date"
                        id="treaty.date"
                    />
                  </div>
                  <div class="col-xxl-6 col-xl-12">
                    <select-field
                        v-model="policy.treaty.term"
                        :options="{12:'12'}"
                        :required="true"
                        :disabled="this.$user.role !== 0"
                        :mb="5"
                        placeholder="Срок (мес)"
                        name="treaty_term"
                        id="treaty.term"
                    />
                  </div>
                  <div class="col-xxl-6 col-xl-12" v-if="!policy.insurer.filter.person">
                    <date-field
                        v-model="policy.paymentData"
                        :required="true"
                        :mb="5"
                        :min="tomorrow"
                        placeholder="Дата оплаты"
                        name="paymentData"
                        id="paymentData"
                    />
                  </div>
                </div>
                <div class="custom-select dynamic">
                  <label for="properties.policy.manager" class="required">Менеджер</label>
                  <v-select
                      :loading="dictionaries.loading.managers"
                      v-model="policy.manager"
                      input-id="properties.policy.manager"
                      :options="dictionaries.managers"
                      :disabled="dictionaries.loading.managers || dictionaries.disabled.manager || policy.hasPaid"
                      :reduce="item => item.id"
                      :required="true"
                      placeholder="Выберите..."
                      class="mb-3 bg-gray-100 form rounded"
                      label="name"
                  />
                </div>
                <div class="custom-select dynamic">
                  <label for="properties.policy.agent">Агент</label>
                  <v-select
                      :loading="dictionaries.loading.agents"
                      v-model="policy.agent"
                      input-id="properties.policy.agent"
                      :options="dictionaries.agents"
                      :disabled="dictionaries.loading.agents || dictionaries.disabled.agent || policy.hasPaid"
                      :reduce="item => item.id"
                      placeholder="Выберите..."
                      class="mb-3 bg-gray-100 form rounded"
                      label="name"
                  />
                </div>
                <div class="custom-select dynamic">
                  <label for="properties.policy.signatory" class="required">Подписант</label>
                  <v-select
                      :loading="!signatories"
                      v-model="policy.signatory"
                      input-id="properties.policy.signatory"
                      :options="signatories"
                      :disabled="!signatories.length || policy.hasPaid"
                      :reduce="item => item.id"
                      :required="true"
                      placeholder="Выберите..."
                      class="mb-3 bg-gray-100 form rounded"
                      label="title"
                  />
                </div>
                <input-mask-field
                    v-if="policy.hasPaid && policy.insurer.filter.person"
                    v-model="policy.paymentPhone"
                    id="policy.paymentPhone"
                    name="policy.paymentPhone"
                    :required="true"
                    :mb="5"
                    placeholder="Номер телефона для оплаты"
                    mask="+7(###) ###-####"
                    type="text"
                />
                <div v-if="!policy.hasPaid">
                  <button v-if="policy.hasSave" @click="saveDraft" type="button"
                          class="btn btn-sm btn-block btn-light-warning mt-1 mb-3">
                    <i v-if="saved" class="fa-solid fa-spinner fa-spin" style="width: 13px;height: 13px;"></i>
                    &nbsp; Сохранить как черновик
                  </button>
                  <button
                      v-if="!policy.hasPaid && policy.hasCalc && !policy.residentRulesError.rule"
                      @click="calculate"
                      :disabled="policy.signatory === null || policy.manager === null"
                      type="button"
                      class="btn btn-sm btn-block btn-primary mt-1"
                  >
                    Рассчитать
                  </button>
                  <button
                      v-if="policy.hasVerify && !policy.hasCalc"
                      :disabled="changeDisabled"
                      @click="verifyDocuments"
                      type="button"
                      class="btn btn-sm btn-block btn-primary mt-1"
                  >
                    Проверить
                  </button>
                </div>
                <div v-if="!acquiringResult.id">
                  <div v-if="policy.hasPaid && !policy.insurer.filter.person">
                    <button @click="checkout(0)"
                            :disabled="!clientSignatoryCheck || !policy.paymentData || !(this.policy.insurer.leader && this.policy.insurer.beneficiaries.length)"
                            class="btn btn-block btn-sm btn-primary cursor-pointer">
                      Перечисление
                    </button>
                  </div>
                  <div v-if="policy.hasPaid && policy.insurer.filter.person">
                    <div class="row">
                      <div class="col-6">
                        <button :disabled="!clientSignatoryCheck" @click="checkout(1, true)" class="btn btn-block btn-sm cursor-pointer btn-primary">
                          Epay
                        </button>
                      </div>
                      <div class="col-6">
                        <button :disabled="!clientSignatoryCheck" @click="checkout(1, false)" class="btn btn-block btn-sm cursor-pointer btn-danger">
                          <svg width="16" height="16" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M16.7475 17.1513C19.6113 17.5934 19.9984 19.2879 20.2299 20.865L20.2685 21.1339L20.2948 21.3169L20.4342 22.245C20.707 24.0171 21.2762 27.6955 21.2762 29.615C21.2762 30.0947 21.234 30.4629 21.1569 30.6652C21.0284 30.977 20.654 31.2762 20.137 31.5256C18.8861 31.8335 17.5786 32 16.2318 32C16.0892 32 15.9489 31.9931 15.8081 31.9889C15.2638 31.8343 14.8547 31.5762 14.6381 31.2235C13.9841 30.1589 13.9447 27.787 13.9316 25.0152L13.9301 24.6937L13.9248 23.8629C13.9035 20.9286 13.8852 18.3986 14.9513 17.4907C15.3642 17.1415 15.9509 17.0259 16.7475 17.1513ZM10.5037 23.5398C11.1243 23.5049 11.5234 26.5574 11.6036 28.8721C11.6598 30.4836 11.4906 31.1465 11.2204 31.3845C10.9145 31.2824 10.6139 31.1719 10.3177 31.0519C10.1201 30.6928 9.96907 30.128 9.87312 29.3882C9.58018 27.0633 9.83465 23.5808 10.5037 23.5398ZM26.0622 28.1014C26.0235 28.3134 25.9689 28.4772 25.9016 28.6154C25.371 29.0412 24.8133 29.4321 24.2297 29.7838C24.0438 29.8151 23.8787 29.7933 23.798 29.6569C23.0245 28.2978 22.7342 24.0342 23.4827 23.6631C24.4586 23.1917 26.2069 27.3643 26.0622 28.1014ZM16.0008 0C24.7145 0 31.8006 6.90062 31.996 15.4873L32 15.7841V15.9213C31.984 19.8 30.5566 23.3486 28.205 26.0952C28.1197 26.0524 27.9641 25.9123 27.6822 25.4906C27.3905 25.0667 24.8749 21.1953 24.8749 16.7581C24.8749 15.8873 26.1301 14.527 27.2408 13.333C28.0711 12.4345 28.8576 11.587 29.1472 10.9209C29.5161 10.0614 29.258 9.46125 28.8498 9.25782C28.4803 9.07703 27.9256 9.2089 27.5363 9.9003C26.8975 11.0193 26.6928 11.2284 25.761 11.9771C24.8441 12.7254 23.3864 13.4787 23.3864 12.5036C23.3864 11.9771 24.1983 10.7847 24.5994 9.9489C25.009 9.10377 24.5675 8.49196 23.7217 8.49196C22.0608 8.49196 20.9583 10.6077 20.9583 11.3407C20.9583 12.0731 21.3136 12.1774 21.3136 13.0303C21.3136 13.8896 19.4913 15.0042 17.7747 15.0042C16.122 15.0042 15.1636 14.6697 14.7665 13.7273L14.7158 13.595L14.601 13.2554C14.1938 12.0653 13.9017 11.2022 13.3932 10.3002C13.1232 9.8232 12.7066 9.49252 12.3463 9.20156C11.8754 8.83579 11.6311 8.49901 11.5801 8.24784C11.5331 7.99865 11.5078 7.52904 12.3128 6.4465C13.1161 5.37014 13.2287 4.557 12.8267 4.13743C12.681 3.98817 12.4326 3.89254 12.1136 3.89254C11.5494 3.89254 10.7654 4.19149 9.95745 5.01265C8.7015 6.2996 9.41451 7.52149 9.41451 8.05788C9.41451 8.59392 9.18442 8.89713 8.43071 9.6264C7.67148 10.3589 7.40945 10.9869 7.32262 13.5109C7.28935 14.8114 7.06031 15.56 6.85471 16.2238C6.67705 16.8056 6.51366 17.3526 6.50483 18.1429C6.49076 19.0187 6.63654 19.5831 6.80666 20.2343C6.97369 20.8362 7.15109 21.5259 7.26475 22.6796C7.44553 24.4655 7.38268 25.9741 7.054 27.516L6.96628 27.9023L6.94578 28.0133C6.87847 28.2843 6.79846 28.6134 6.69031 28.7367C2.64076 25.8604 0 21.163 0 15.8531C0 7.09843 7.1635 0 16.0008 0Z" fill="#FFF"/>
                          </svg>
                          Kaspi
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <button
                      @click="checkPayment()"
                      class="btn btn-block btn-sm cursor-pointer"
                      :class="!policy.isEpay ? 'btn-danger' : 'btn-primary'"
                      :disabled="this.acquiringResult.loaded"
                      v-html="this.acquiringResult.loaded ? 'Идет проверка' : 'Проверить оплату'"
                  ></button>
                  <router-link v-if="policy.isEpay" :to="{name: 'EpayPayment', params: {id: policyId}}" class="btn btn-sm btn-block btn-light-primary mt-3" target="_blank">Открыть страницу оплаты</router-link>
                  <div v-if="acquiringResult.waiting" class="text-danger pt-3 text-center"
                       v-html="acquiringResult.waiting"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section v-if="ticket">
      <div class="rounded border p-6 bg-white info-panel mb-3 w-300px m-auto">
        <div class="mb-5 text-center">
          <i class="ki-outline ki-check-circle text-primary fs-7qx"></i>
        </div>
        <div class="first-info">
          <div class="fw-bold fs-6 text-primary mb-2 text-center">Договор успешно создан</div>
          <div class="text-gray-500" v-if="ticket.number">
            Номер: <span class="float-end text-gray-700 fw-bold" v-html="ticket.number"></span>
          </div>
          <div class="text-gray-500">
            Глобальный: <span class="float-end text-gray-700 fw-bold" v-html="ticket.global"></span>
          </div>
          <div class="text-gray-500">
            Дата начала: <span class="float-end text-gray-700 fw-bold" v-html="ticket.to"></span>
          </div>
          <div class="text-gray-500">
            Дата конца: <span class="float-end text-gray-700 fw-bold" v-html="ticket.from"></span>
          </div>
        </div>
        <a v-if="ticket.ticket" :href="ticket.ticket" target="_blank"
           class="btn btn-sm btn-primary btn-block mt-5 mb-2">Посмотреть чек</a>
        <span @click="this.$router.go(0)" class="btn btn-sm btn-light btn-block mt-5 mb-2 cursor-pointer">OK</span>
      </div>
    </section>
    <customer-modal
        :client-added-list="policy.clientAddedList"
        :client="changedClient"
        @addClient="addClient"
        :module="FiModule"/>
    <chief-modal
        :is-leader="changedChief.isLeader"
        :hash="changedChief.hash"
        :chief-added-list="chiefAddedListForModal"
        @addChief="addChief"/>
    <property-one-c-modal
        v-if="policy.insurer"
        @addObject="addObject"
        :is-person="policy.insurer.filter.person"
        :properties="changedObject"
        :beneficiary="policy.beneficiary"
        :is-immovable="policy.conditions.is_immovable"
        :module="FiModule"/>
    <insurance-risks :risks="policy.risks"/>
    <podft-upload-modal
        :number="modalData.number"
        :index="modalData.index"
        :text="modalData.text"
        :type="modalData.type"
        :ulid="policy.number"
        @updatePodftData="updatePodftData"/>
    <alert-modal title="У вас не настроен терминал!"
                 description="Пожалуйста, обратитесь к ответственному бухгалтеру. <br/>Если терминал настроен, необходимо обновить токен или вновь авторизоваться.<br/><br/>Без терминала нельзя заключить полис!"
                 :timer="3"/>
    <policy-history-popup :product="this.policy.product"/>
  </section>
  <template v-else>
    <loader-full :text="loaderText"/>
  </template>
</template>

<script>
// Fields
import SwitchBoxField   from '@/components/Fields/SwitchBoxField'
import InputMaskField   from '@/components/Fields/InputMaskField'
import CheckboxField    from '@/components/Fields/CheckboxField'
import SelectField      from '@/components/Fields/SelectField'
import InputField       from '@/components/Fields/InputField'
import DateField        from '@/components/Fields/DateField'
// Form
import ProgramCondition   from '@/components/Form/OneC/Components/ProgramCondition'
import ObjectOneCCard     from '@/components/Form/OneC/Card/ObjectOneCCard'
import CustomerCard       from '@/components/Form/Customer/CustomerCard'
//Modal
import PropertyOneCModal  from '@/components/Form/OneC/Modals/PropertyOneCModal'
import PodftUploadModal   from '@/components/Podft/PodftUploadModal'
import InsuranceRisks     from '@/components/Form/OneC/Modals/InsuranceRisksModal'
import CustomerModal      from '@/components/Form/Customer/CustomerModal'
import ChiefModal         from '@/components/Form/Uidb/Modals/ChiefModal'
// Other
import permissions    from '@/helpers/permissions'
import LoaderFull     from '@/components/Main/LoaderFull'
import FiModule       from "@/helpers/Modules/Product/FiModule";
import vSelect        from 'vue-select'
import {ulid}         from 'ulidx'
import axios          from 'axios'
import AlertMain      from "@/components/Main/AlertMain.vue";
import AlertModal     from "@/components/Main/AlertModal.vue";
import PolicyHistoryPopup from "@/components/Policy/PolicyHistoryPopup.vue";

export default {
  name: 'Properties',
  components: {
    PolicyHistoryPopup,
    AlertModal, AlertMain, PropertyOneCModal, ProgramCondition, PodftUploadModal, CustomerModal, CustomerCard, InsuranceRisks, InputMaskField,
    ObjectOneCCard, SwitchBoxField, CheckboxField, SelectField, ChiefModal, InputField, LoaderFull, DateField, vSelect },
  data() {
    return {
      FiModule,
      policy: {
        ip:             null,
        isEpay:         null,
        paymentPhone:   null,
        paymentData:    null,
        signatory:      null,
        manager:        null,
        agent:          null,
        insureds:       [],
        insurer:        null,
        beneficiary:    null,
        objects:        [],
        product:        'DSD_FI',
        number:         null,
        risks: {
          third_party_actions:  0,
          natural_disasters:    10,
          earthquake_fire:      10,
          plane_crash:          0,
          earthquake:           10,
          total_loss:           10,
          explosion:            10,
          lightning:            10,
          flooding:             0,
          fire:                 10,
        },
        conditions: {
          is_immovable:   false,
          kind:           null,
          has_losses:     false,
          is_indoors:     true,
        },
        treaty: {
          date: '',
          term: 12
        },
        programCondition: {
          insuredSum:   0,
          franchise:    1,
          av:           '0',
          md:           '0',
        },
        calculationDate:  null,
        isDrive:          false,
        premium:          null,
        hasPaid:          false,
        hasVerify:        false,
        hasCalc:          false,
        hasSave:          false,
        clientAddedList:  [],
        chiefAddedList:   [],
        carAddedList:     [],
        residentRules: {
          insurer:  null,
          insured:  [],
        },
        residentRulesError: {
          rule:   null,
          text:   null,
          key:    null
        },
        selected: {
          kind:   null,
        },
        podftSuccess: true
      },
      envState:       process.env.VUE_APP_STATE,
      isEpay:         false,
      saved:    false,
      loaded:   false,
      loaderText: '',
      changedClient: {
        new:        true,
        key:        null,
        data:       null,
        isInsurer:  null
      },
      changedChief: {
        isLeader:   false,
        hash:       null
      },
      changedObject:    null,
      errorClientKey:   [],
      changeDisabled:   false,
      isInsurer:        false,
      modalData: {
        number:     '',
        index:      '',
        text:       '',
        type:       ''
      },
      ticket:       null,
      acquiringResult: {
        waiting:    null,
        loaded:     false,
        id:         null
      },
      iin:              null,
      hasGlobalVerify:  true,
      insurerBmgError: {
        error:    null,
        phone:    '7',
        iin:      null
      },
      dictionaries: {
        managers:   [],
        agents:     [],
        loading: {
          managers:   false,
          agents:     false,
        },
        disabled: {
          manager:  false,
          agent:    false,
        }
      },
      clientSignatoryCheck: false,
      policyId: null
    }
  },
  mounted() {
    if (this.$route.query.draft) {
      this.loaded = true
      axios.get('/api/draft/item/' + this.$route.query.draft+'/_FI')
          .then(res => {
            if (res.data.policy && (res.data.policy.product === 'DSD_FI' || res.data.policy.product === 'DSI_FI')) {
              if (res.data.policy.isDrive) {
                res.data.policy.insureds.splice(0, 1)
                const index = res.data.policy.clientAddedList.indexOf(res.data.policy.insurer.client.iin);
                res.data.policy.clientAddedList.splice(index, 1);
              }
              this.policy = res.data.policy
              if (!this.policy.insurer.leader) this.policy.insurer['leader'] = null
              if (!this.policy.insurer.beneficiaries) this.policy.insurer['beneficiaries'] = []
              this.policy.treaty.date = this.tomorrow
              if (!this.policy.number && this.$route.query.draft) this.policy.number = parseInt(this.$route.query.draft)
              if (/^\d+$/.test(this.$route.query.draft)) this.policy.number = ulid()
            } else {
              this.$notifyError({message:'Черновик не найден'})
            }
          })
          .catch(err => {
            this.$notifyError(err)
          })
          .finally(() => {
            this.loaded                 = false
            this.policy.hasPaid         = false
            this.policy.hasCalc         = false
            this.policy.premium         = null
            this.policy.calculationDate = null
            this.getManagers()
          })
    } else {
        this.getManagers()
    }
    this.$store.dispatch('signatoriesRequest')
    this.$store.dispatch('regionsFIRequest')
    this.policy.treaty.date = this.tomorrow
    if (!this.$route.query.hasOwnProperty('draft')) this.policy.number = ulid()
    this.getIp()
        .then(res => {this.policy.ip = res.data.ip})
        .catch(() => {
          confirm(`Ошибка загрузки продукта`) ? location.reload() : location.reload()
        });
  },
  computed: {
    tomorrow() {
      let tomorrow = new Date(Date.now() + (3600 * 1000 * 24))
      return tomorrow.toISOString().split('T')[0]
    },
    signatories() {return this.$store.getters.getSignatories},
    getUser() {return this.$store.state.user},
    chiefAddedListForModal() {
      const findDuplicates = (arr) => {
        const seen = new Set();
        const duplicates = new Set();

        arr.forEach((item) => {
          if (seen.has(item)) {
            duplicates.add(item);
          } else {
            seen.add(item);
          }
        });

        return [...duplicates];
      };

      const {chiefAddedList, insurer} = this.policy;
      const duplicates = findDuplicates(chiefAddedList);

      const filterCondition = this.changedChief.isLeader
          ? (item) => {
            if (!insurer.beneficiaries || !Array.isArray(insurer.beneficiaries)) {
              return true;
            }
            return !insurer.beneficiaries.some((leader) => leader.doc === item);
          }
          : (item) => {
            if (!insurer.leader || !insurer.leader.doc) {
              return true;
            }
            return item !== insurer.leader.doc;
          };
      return [
        ...chiefAddedList.filter(filterCondition),
        ...duplicates,
      ];
    },
    getUser() {
      return this.$store.state.user
    },
  },
  methods: {
    async getIp() {return await axios.get('api/get-ip')},
    setClient(clientType, data = null, key = null) {
      this.changedClient = {clientType: clientType, data: structuredClone(data), key: key}
      setTimeout(() => {new bootstrap.Modal('#customerModal', {}).show()}, 10)
    },
    addClient(val) {
      let data = structuredClone(val.data)
      switch (val.clientType) {
        case 1:
          this.addInsurer(data)
          break
        case 2:
          this.addInsured(data, val.key)
          break
        case 3:
          this.addBeneficiary(data)
          break
        case 4:
          this.addLeader(data)
          break
        case 5:
          this.addOwner(data)
          break
      }
    },
    deleteClient(key) {
      if (this.policy.insureds[key].client.iin === "" && this.policy.insureds[key].document?.number === null) {
        this.policy.insureds.splice(key, 1)
        return
      }
      if ((this.policy.insureds[key].client.iin ? this.policy.insureds[key].client.iin === this.policy.insurer.client.iin : this.policy.insureds[key].document?.number === this.policy.insurer.document?.number) &&
          !((this.policy.insurer.entrepreneur && this.policy.insurer.entrepreneur.name) || (this.policy.insureds[key].entrepreneur && this.policy.insureds[key].entrepreneur.name))) {
        this.policy.isDrive = false
      } else {
        this.policy.clientAddedList.splice(key, 1)
        if (this.policy.insureds[key].client.isInsurer) {
          this.policy.insureds.splice(key, 1)
          if (this.policy.insureds.length !== 0) {
            this.policy.insureds[0].client.isInsurer = true
          }
        } else {
          this.policy.insureds.splice(key, 1)
        }
      }
    },
    addInsurer(data) {
      this.policy.insurer = data;
      if (this.policy.isDrive && (data.client.iin === this.policy.insurer.client.iin)) {
        this.policy.insurer = data
      }
    },
    addInsured(data, key = null) {
      if ((data.client.iin ? data.client.iin === this.policy.insurer.client.iin : data.document?.number === this.policy.insurer.document?.number) &&
          !((this.policy.insurer.entrepreneur && this.policy.insurer.entrepreneur.name) || (data.entrepreneur && data.entrepreneur.name))) {
        this.policy.isDrive = true;
        this.policy.insurer.client.politician = data.client.politician
      } else if (key === null) {
        this.policy.insureds.push(data);
        if (!(data.entrepreneur && data.entrepreneur.name)) {
          this.policy.clientAddedList.push(data.client.iin ?? data.document?.number);
        }
      } else {
        this.policy.insureds[key] = data;
      }
    },
    addBeneficiary(data) {
      this.policy.beneficiary = data
    },
    addOwner(data) {
      this.policy.insurer.beneficiaries.push(data.user)
      if (!this.policy.hasOwnProperty('chiefAddedList')) this.policy.chiefAddedList = []
      this.policy.chiefAddedList.push(data.client.iin ?? data.document?.number)
    },
    addLeader(data) {
      this.policy.insurer.leader = data
      if (!this.policy.hasOwnProperty('chiefAddedList')) this.policy.chiefAddedList = []
      this.policy.chiefAddedList.push(data.user.doc)
    },
    setChief(isLeader = false) {
      this.changedChief = {isLeader: isLeader, hash: Math.floor(Math.random() * 10) + 1}
      new bootstrap.Modal('#ChiefModal', {}).show()
    },
    addChief(val) {
      if (this.changedChief.isLeader) {
        this.policy.insurer.leader = val.user
      } else {
        this.policy.insurer.beneficiaries.push(val.user)
      }
      if (!this.policy.hasOwnProperty('chiefAddedList')) this.policy.chiefAddedList = []
      this.policy.chiefAddedList.push(val.user.doc)
      const myModalEl = document.getElementById('ChiefModal')
      const modal = bootstrap.Modal.getInstance(myModalEl)
      modal.hide()
    },
    deleteChief(key, isLeader = false) {
      const docNum = isLeader ? this.policy.insurer.leader.doc : this.policy.insurer.beneficiaries[key].doc
      const docKey = this.policy.chiefAddedList.indexOf(docNum)
      if (isLeader) {
        this.policy.insurer.leader = null
      } else {
        this.policy.insurer.beneficiaries.splice(key, 1)
      }
      this.policy.chiefAddedList.splice(docKey, 1);
    },
    setChangedObject(key, isEdit) {
      this.changedObject = {
        isEdit: isEdit,
        data:   structuredClone(this.policy.objects[key]),
        key:    key
      }
      new bootstrap.Modal('#objectOneCModal', {}).show()
    },
    setObject() {
      this.changedObject = {
        isEdit: false,
        data:   null,
        key:    null
      }
      new bootstrap.Modal('#objectOneCModal', {}).show()
    },
    addObject(val) {
      this.policy.hasPaid         = false
      this.policy.hasCalc         = false
      this.policy.premium         = null
      this.policy.calculationDate = null
      if (val.isEdit) {
        this.policy.objects[val.key] = val.data
      } else {
        this.policy.objects.push(structuredClone(val.data))
      }
      this.policy.changedObject = null
    },
    deleteObject(key) {
      this.policy.objects.splice(key, 1)
    },
    saveDraft() {
      this.saved = true
      const headers = {policy: this.policy}
      axios.post('/api/draft/save', headers)
          .then(res => {
            this.policy.number = res.data
            this.$notifySuccess({message: res.data, title: 'Сохранено'})
          })
          .catch(err => {
            this.$notifyError(err)
          })
          .finally(() => {
            this.saved = false
          })
    },
    uploadData(number, text, type, index) {
      this.modalData.number     = number
      this.modalData.index      = index
      this.modalData.text       = text
      this.modalData.type       = type
      new bootstrap.Modal('#podftUploadModal', {}).show()
    },
    updatePodftData(val) {
      if (val.type === 0) {
        this.policy.insurer.podft             = val.data
      } else if (val.type === 1) {
        this.policy.insureds[val.index].podft = val.data
      }
      this.saveDraft()
    },
    getDocType() {
      let data = [
        {id: 'Свидетельство', name: 'Свидетельство'},
        {id: 'Талон',         name: 'Талон'}
      ]
      if (!this.policy.insurer.filter.person) {
        data = [
          {id: 'Устав',         name: 'Устав'},
          {id: 'Доверенность',  name: 'Доверенность'},
          {id: 'Приказ',        name: 'Приказ'}
        ]
      }
      return data
    },
    checkInsurerSignatory() {
      let result = false
      if (!this.policy.insurer.filter.person || (this.policy.insurer.entrepreneur && this.policy.insurer.entrepreneur.number)) {
        if (this.policy.insurer.signatory.resident) {
          result = this.policy.insurer.signatory.surname
              && this.policy.insurer.signatory.name
              && this.policy.insurer.signatory.iin
              && this.policy.insurer.signatory.position
              && this.policy.insurer.signatory.foundation_type
          if (this.policy.insurer.signatory.foundation_type !== 'Устав') {
            result = result && this.policy.insurer.signatory.foundation_number && this.policy.insurer.signatory.foundation_date
          }
        } else {
          result = this.policy.insurer.signatory.surname
              && this.policy.insurer.signatory.name
              && this.policy.insurer.signatory.position
              && this.policy.insurer.signatory.foundation_type
              && this.policy.insurer.signatory.foundation_number
              && this.policy.insurer.signatory.foundation_date
        }
        return result
      }
    },
    // Verify
    async verifyDocuments() {
      if (this.getUser && !this.getUser.hasTerminal && permissions.groupSale().includes(this.getUser.role) && this.getUser.role !== 0) {
        new bootstrap.Modal('#alertModal', {}).show()
      }
      this.changeDisabled = true
      this.policy.podftSuccess = true
      this.verifyClient(true, this.policy.insurer, this.policy.number)
          .then(res => {
            if (!res.data.hasOwnProperty('success')) {
              this.policy.podftSuccess                = false
              this.policy.insurer.podft.message       = 'Время ожидания ответа от сервера истекло. Попробуйте снова.'
              this.policy.insurer.podft.error         = res.data
              this.policy.insurer.podft.setDocument   = false
              this.policy.insurer.podft.success       = false
              if (res.data.hasOwnProperty('result') && !res.data.result) {
                this.$notifyError(res.data)
              }
            } else {
              this.policy.insurer.podft = res.data
              if (!res.data.success) this.policy.podftSuccess = res.data.success
            }
          })
          .catch(err => {
            console.log(err.message)
            this.policy.podftSuccess = false
            this.policy.insurer.podft.message = 'Обновите страницу (Ctrl + Shift + R) и попробуйте снова.'
            this.policy.insurer.podft.setDocument = false
            this.policy.insurer.podft.success = false
          })
          .finally(async () => {
            this.policy.insurer.beingVerify = false
            for (const key in this.policy.insureds) {
              if ((this.policy.insureds[key].client.iin ?? this.policy.insureds[key].document?.number) !== (this.policy.insurer.client.iin ?? this.policy.insurer.document?.number)) {
                await this.verifyClient(false, this.policy.insureds[key], this.policy.number)
                    .then(res => {
                      if (!res.data.hasOwnProperty('success')) {
                        this.policy.podftSuccess = false
                        this.policy.insureds[key].message     = 'Время ожидания ответа от сервера истекло. Попробуйте снова.'
                        this.policy.insureds[key].error       = res.data
                        this.policy.insureds[key].setDocument = false
                        this.policy.insureds[key].success     = false
                        if (res.data.hasOwnProperty('result') && !res.data.result) {
                          this.$notifyError(res.data)
                        }
                      } else {
                        this.policy.insureds[key].podft = res.data
                        if (!res.data.success) this.policy.podftSuccess = res.data.success
                      }
                    })
                    .catch(err => {
                      console.log(err.message)
                      this.policy.podftSuccess = false
                      this.policy.insureds[key].message = 'Обновите страницу (Ctrl + Shift + R) и попробуйте снова.'
                      this.policy.insureds[key].error = err.message
                      this.policy.insureds[key].setDocument = false
                      this.policy.insureds[key].success = false
                    })
                    .finally(() => {this.policy.insureds[key].beingVerify = false})
              }
            }
            if (this.$user.role !== 0) {
              await this.verifyTerminal(this.$user.c_id)
                  .then(res => {
                    if (!res.data.result) {
                      this.policy.podftSuccess = false
                      this.$notifyError(res.data)
                    }
                  }).catch(err => {
                    console.log(err.message)
                  })
            }
            this.changeDisabled = false
            setTimeout(() => {this.policy.hasCalc = this.policy.podftSuccess}, 500)
            if (!this.policy.podftSuccess) this.saveDraft()
          })

    },
    async verifyClient(isInsured, data, ulid) {
      data.beingVerify = true
      let headers = {
        // unprofitable: this.policy.insurer.unprofitable.result,
        isEntrepreneur: data.client?.entrepreneur ? 1 : 0,
        patronymic:     data.client.patronymic,
        isInsured:      isInsured,
        surname:        data.client.surname,
        product:        this.policy.product,
        rewrite:        false,
        person:         data.filter.person,
        title:          data.client.title,
        phone:          data.client.phone,
        name:           data.client.name,
        iin:            data.client.iin,
        ulid:           ulid,
      }
      return await axios.post('/api/verify/client-fi', headers)
    },
    async verifyTerminal(c_id) {
      return await axios.post('/api/verify/terminal', {c_id: c_id})
    },
    // Policy
    calculate() {
      if (!this.policy.ip) this.getIp()
      this.loaderText = 'Идет калькуляция'
      this.loaded = true
      axios.post('/api/calculate/financial-institutions', {policy: this.policy})
          .then(res => {
            if (res.data.errors) {
              this.$notifyError(res.data)
            } else {
              if (res.data.result) {
                this.policy.tariff = res.data.items[0].tariff ?? null
                Object.keys(res.data.items).forEach(key => {
                  this.policy.objects[key].calc    = res.data.items[key]
                  this.policy.objects[key].premium = res.data.items[key].premium
                });
                setTimeout(() => {
                  this.policy.premium         = res.data.premium
                  this.policy.calculationDate = res.data.calculationDate
                  this.policy.hasPaid         = res.data.result
                  this.policy.hasCalc         = res.data.result
                }, 400)
              } else {
                this.$notifyError(res.data)
              }
            }
          })
          .catch(err => {
            this.$notifyError(err)
          })
          .finally(() => {
            this.loaderText = ''
            this.loaded = false
          })
    },
    checkout(type, isEpay) {
      if (type === 1) this.policy.isEpay = isEpay
      this.loaded         = true
      this.changeDisabled = true
      this.loaderText     = 'Идет создание полиса'
      const headers = {payment: type, policy: this.policy, paymentPhone: this.policy.paymentPhone}
      axios.post('api/contracts/checkout-fi', headers)
          .then(res => {
            if (res.data.global) {
              this.ticket = res.data
            } else if (res.data.result) {
              this.acquiringResult.id = isEpay ? res.data.policyId : res.data.result
              if (this.policy.isEpay) this.policyId = res.data.policyId
            } else {
              this.$notifyError(res.data)
            }
          })
          .catch(err => {
            this.$notifyError({message: 'Ошибка выставления счета, попробуйте ещё раз.'})
          })
          .finally(() => {
            this.loaderText = ''
            this.loaded = false
          })
    },
    checkPayment(payment = 1) {
      this.acquiringResult.loaded = true
      const headers = {id: this.acquiringResult.id, payment: payment}
      axios.post('api/contracts/check-payment', headers)
          .then(res => {
            if (res.data.ticket) this.ticket = res.data
            if (res.data.waiting) {
              this.acquiringResult.waiting = res.data.waiting
              setTimeout(() => {
                this.acquiringResult.waiting = null
              }, 3000)
            }
          })
          .catch(err => {
            this.$notifyError({message: 'Ошибка проверки оплаты, попробуйте ещё раз.'})
          })
          .finally(() => {this.acquiringResult.loaded = false})
    },
    // Dictionaries
    getManagers() {
      this.dictionaries.loading.managers = true
      axios.get('/api/dictionaries/order/managers')
          .then(res => {
            if (res.data.result) this.dictionaries.managers = res.data.data
          })
          .catch(err => this.$notifyError({message: err?.response?.data?.message ?? err.message}))
          .finally(() => {
            this.dictionaries.loading.managers = false
            if (this.$user.role === 3) {
              this.policy.manager = this.$user.id
              this.dictionaries.disabled.manager = true
            }
            if (this.$user.role === 4) {
              if (this.dictionaries.managers.length) {
                this.policy.manager = this.dictionaries.managers[0].id
                this.dictionaries.disabled.manager = true
              }
            }
          })
    },
    kinds() { return FiModule.Dictionary.kinds(this.policy.conditions.is_immovable) },
  },
  watch: {
    policy: {
      deep: true,
      handler() {
        const insurerInsuredsLength = this.policy.insurer && this.policy.insureds.length > 0
        this.policy.hasVerify       = insurerInsuredsLength && !!this.policy.beneficiary && !!this.policy.programCondition.insuredSum
        this.policy.hasSave         = (insurerInsuredsLength && !!this.policy.objects)
        if (this.errorClientKey) this.errorClientKey = []
        if (this.policy.insurer && ('signatory' in this.policy.insurer) && this.policy.insurer.signatory) {
          this.clientSignatoryCheck = this.checkInsurerSignatory()
        }
      }
    },
    'policy.isDrive': {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          if (!(this.policy.insurer.entrepreneur && this.policy.insurer.entrepreneur.name)) {
            this.policy.clientAddedList.unshift(this.policy.insurer.client.iin ?? this.policy.insurer.document?.number)
          }
          this.policy.insureds.unshift(structuredClone(this.policy.insurer))
        } else {
          if (this.policy.insurer) {
            if (!(this.policy.insurer.entrepreneur && this.policy.insurer.entrepreneur.name)) {
              let index = this.policy.clientAddedList.indexOf(this.policy.insurer.client.iin);
              if (!index) index = this.policy.clientAddedList.indexOf(this.policy.insurer.document?.number);
              this.policy.clientAddedList.splice(index, 1);
            }
            this.policy.insureds.shift()
          }
        }
      }
    },
    'policy.insureds': {
      deep: true,
      handler(newValue) {
        if (newValue) this.policy.hasPaid = false
        this.policy.hasCalc               = false
        this.policy.premium               = null
        this.policy.calculationDate       = null
        let data = []
        Object.entries(newValue).forEach(([key, value]) => {data[key] = value.filter.resident});
        this.policy.residentRules.insured = data
      }
    },
    'policy.objects': {
      deep: true,
      handler(newValue) {
        if (newValue) this.policy.hasPaid = false
        this.policy.hasCalc               = false
        this.policy.premium               = null
        this.policy.calculationDate       = null
        let amountTotal                   = 0
        this.policy.objects.forEach((element) => {amountTotal = amountTotal + element.amount});
        this.policy.programCondition.insuredSum = amountTotal
      }
    },
    'policy.hasPaid': {
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.policy.paymentPhone = structuredClone(this.policy.insurer.client.phone)
        }
      }
    },
    'policy.insurer': {
      deep: true,
      handler(newValue) {
        if (newValue && newValue.hasOwnProperty('filter')) {
          this.policy.residentRules.insurer = newValue.filter.resident
          if (newValue.filter.person) this.policy.paymentPhone = this.policy.insurer.client.phone
        }
        if (!newValue.filter.person || (newValue.entrepreneur && newValue.entrepreneur.number)) {
          if (!newValue.signatory) {
            this.clientSignatoryCheck = false
            this.policy.insurer.signatory = {
              resident:             true,
              iin:                  null,
              surname:              null,
              name:                 null,
              patronymic:           null,
              position:             null,
              foundation_type:      null,
              foundation_number:    null,
              foundation_date:      null,
            }
          }
        } else {
          this.clientSignatoryCheck = true
          delete this.policy.insurer.signatory
        }
      }
    },
    'policy.beneficiary': {
      deep: true,
      handler(newValue) {
        this.policy.hasPaid         = false
        this.policy.hasCalc         = false
        this.policy.premium         = null
        this.policy.calculationDate = null
      }
    },
    'policy.paymentPhone': {
      immediate: true,
      handler(newValue) {
        if (!newValue) this.policy.paymentPhone = '7'
      }
    },
    'policy.programCondition': {
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.policy.hasPaid         = false
          this.policy.hasCalc         = false
          this.policy.premium         = null
          this.policy.calculationDate = null
        }
      }
    },
    'policy.conditions': {
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.policy.hasPaid         = false
          this.policy.hasCalc         = false
          this.policy.premium         = null
          this.policy.calculationDate = null
        }
      }
    },
    'policy.conditions.is_immovable': {
      deep: true,
      handler(newValue) {this.policy.product = newValue ? 'DSI_FI' : 'DSD_FI'}
    },
    'policy.programCondition.franchise': {
      immediate: true,
      handler(newValue) {
        this.policy.risks.third_party_actions = newValue
        this.policy.risks.plane_crash         = newValue
        this.policy.risks.flooding            = newValue
      }
    },
    'policy.manager': {
      immediate: true,
      handler(val) {
        if (val) {
          this.policy.agent = null
          this.dictionaries.loading.agents = true
          const headers = {id: val, product: this.policy.product}
          axios.post('/api/dictionaries/order/agents', headers)
              .then(res => {
                if (res.data.result && res.data.data) this.dictionaries.agents = res.data.data
                if (this.$user.role === 4) {
                  if (this.dictionaries.agents.length) {
                    if (res.data.hasOwnProperty('isCompany') && res.data.isCompany) {
                      this.policy.agent = this.dictionaries.agents[0].id
                    } else {
                      this.policy.agent = this.$user.id
                    }
                    this.dictionaries.disabled.agent = true
                  }
                }
              })
              .catch(err => this.$notifyError({message: err?.response?.data?.message ?? err.message}))
              .finally(() => {
                this.dictionaries.loading.agents = false
              })
        } else {
          this.dictionaries.agents  = []
          this.policy.agent         = null
        }
      }
    },
    'policy.treaty': {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.policy.hasPaid = false
        this.policy.hasCalc = false
        this.policy.premium = null
        this.policy.calculationDate = null
      }
    },
    getUser: {
      immediate: true,
      handler(newValue) {
        if (newValue && !newValue.hasTerminal && permissions.groupSale().includes(newValue.role) && newValue.role !== 0) {
          setTimeout(() => {
            new bootstrap.Modal('#alertModal', {}).show()
          }, 150)
        }
      }
    }
  }
}
</script>

<style scoped>

</style>